import React from 'react';

const GoogleLogo = () => {
    return (
        <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1031_10174)">
                <path d="M6.04664 14.3046L5.23971 17.317L2.29041 17.3794C1.40901 15.7446 0.909058 13.8741 0.909058 11.8865C0.909058 9.96441 1.3765 8.15188 2.20507 6.55591H2.2057L4.8314 7.03729L5.98162 9.64724C5.74088 10.3491 5.60967 11.1025 5.60967 11.8865C5.60976 12.7373 5.76388 13.5525 6.04664 14.3046Z" fill="#FBBB00" />
                <path d="M23.8883 9.7207C24.0214 10.4219 24.0908 11.146 24.0908 11.886C24.0908 12.7159 24.0036 13.5253 23.8374 14.3061C23.2731 16.9631 21.7988 19.2832 19.7564 20.925L19.7558 20.9244L16.4485 20.7557L15.9805 17.8337C17.3357 17.0389 18.3948 15.7951 18.9527 14.3061H12.7548V9.7207H19.0431H23.8883Z" fill="#518EF8" />
                <path d="M19.7556 20.9249L19.7563 20.9255C17.7699 22.5221 15.2466 23.4774 12.4998 23.4774C8.08574 23.4774 4.24802 21.0102 2.29028 17.3794L6.04651 14.3047C7.02535 16.9171 9.54543 18.7767 12.4998 18.7767C13.7697 18.7767 14.9594 18.4335 15.9803 17.8342L19.7556 20.9249Z" fill="#28B446" />
                <path d="M19.8984 2.96385L16.1435 6.03798C15.0869 5.37757 13.838 4.99607 12.5 4.99607C9.47869 4.99607 6.91148 6.94103 5.98168 9.6471L2.20571 6.55577H2.20508C4.13415 2.83649 8.02027 0.29541 12.5 0.29541C15.3124 0.29541 17.891 1.29721 19.8984 2.96385Z" fill="#F14336" />
            </g>
            <defs>
                <clipPath id="clip0_1031_10174">
                    <rect width="23.1818" height="23.1818" fill="white" transform="translate(0.909058 0.29541)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default GoogleLogo;
